/**
 * Shared MUI DataGrid sx overrides for calendar-week alternating row bands.
 * Even/odd ISO week rows get subtly different backgrounds so CW groups are
 * visually distinguishable without relying on colour.
 *
 * Usage:
 *   <DataGridPro sx={cwDataGridSx} getRowClassName={makeCwRowClassName(dateField)} />
 */

const pinnedSelector = (weekClass) =>
  ['.MuiDataGrid-cell--pinnedLeft', '.MuiDataGrid-cell--pinnedRight']
    .flatMap((pin) => [
      `& .${weekClass} ${pin}`,
      `& .${weekClass}:hover ${pin}`,
      `& .${weekClass}.Mui-hovered ${pin}`,
    ])
    .join(', ');

const weekStates = (weekClass) =>
  `& .${weekClass}, & .${weekClass}:hover, & .${weekClass}.Mui-hovered`;

export const cwDataGridSx = {
  [weekStates('week-even')]: {
    backgroundColor: (t) =>
      t.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.04) !important'
        : 'rgba(0, 0, 0, 0.02) !important',
  },
  [pinnedSelector('week-even')]: {
    backgroundColor: (t) =>
      t.palette.mode === 'dark' ? '#1a1a1a !important' : '#fafafa !important',
  },
  [weekStates('week-odd')]: {
    backgroundColor: (t) =>
      t.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.18) !important'
        : 'rgba(0, 0, 0, 0.06) !important',
  },
  [pinnedSelector('week-odd')]: {
    backgroundColor: (t) =>
      t.palette.mode === 'dark' ? '#2e2e2e !important' : '#f0f0f0 !important',
  },
};
